import { render, staticRenderFns } from "./ThuxListMixin.vue?vue&type=template&id=52307b87&"
import script from "./ThuxListMixin.vue?vue&type=script&lang=js&"
export * from "./ThuxListMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports